import React, { useEffect, useRef, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { getIn } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { loadMapplsSearchPlugin } from 'lib/mappls';

const FormikMaterialTextField = (props) => {
  const {
    field,
    form: { touched, errors },
    variant,
    disabled,
    cb,
    ...rest
  } = props;

  const [inputValue, setInputValue] = useState('');
  const inputIdRef = useRef(`mappls-search-${Math.random().toString(36).slice(2)}`);
  const cbRef = useRef(cb);

  useEffect(() => {
    setInputValue(field.value);
  }, [field.value]);

  const handleInputChange = (e) => {
    let value = e.target.value;
    setInputValue(value);
  };

  // useEffect(() => {
  //   const script = document.createElement('script');

  //   script.src = `https://apis.mapmyindia.com/advancedmaps/api/${token}/map_sdk_plugins`;
  //   script.async = true;
  //   script.onload = () => {
  //     // Place search plugin

  // let optional_config = {
  //   location: [28.61, 77.23],
  //   bridge: false,
  //   tokenizeAddress: true,
  //   geolocation: false,
  //   pod: 'DIST',
  // };

  //     window.MapmyIndia.search(document.getElementById('auto1'), optional_config, function (data1) {
  //       //pass data to callback function
  //       cb(data1);
  //     });
  //   };
  //   document.head.appendChild(script);
  //   // remove script after adding
  //   setTimeout(() => {
  //     document.head.removeChild(script);
  //   }, 100);
  // }, [token]);

  useEffect(() => {
    let isMounted = true;

    loadMapplsSearchPlugin()
      .then((mappls) => {
        const inputElement = document.getElementById(inputIdRef.current);
        if (!isMounted || !inputElement || !mappls?.search) {
          return;
        }

        const optional_config = {
          location: [28.61, 77.23],
          bridge: false,
          tokenizeAddress: true,
          geolocation: false,
          pod: 'DIST',
        };

        new mappls.search(inputElement, optional_config, function (data) {
          if (!isMounted) {
            return;
          }

          console.log('mappls data2 >>', data);
          cbRef.current && cbRef.current(data);
        });
      })
      .catch((err) => {
        console.error('Mappls search failed to load', err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      <input
        type="text"
        id={inputIdRef.current}
        name={inputIdRef.current}
        className="search-outer form-control as-input"
        placeholder="Search location"
        required=""
        spellCheck="false"
        value={inputValue}
        disabled={disabled}
        onChange={handleInputChange}></input>

      <span
        style={{
          color: 'var(--unnamed-color-f44336)',
          fontSize: 'var(--fs-base__three)',
          fontFamily: 'var(--unnamed-font-segoeUI)',
        }}>
        {errors.location_code}
      </span>
    </div>
  );
};

export default FormikMaterialTextField;
